import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import PreviewIcon from '@mui/icons-material/Preview';
import {
	Badge,
	Box,
	IconButton,
	List,
	ListItem,
	ListItemButton,
	ListItemText
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import OperationImage from '../../../../../../assets/images/operation.png';
import { RolesTypes } from '../../../../../../config/roles';
import { AppRoutes } from '../../../../../../constants/appRoutes';
import { BecomeProStatuses } from '../../../../../../constants/becomeProStatuses';
import { InvestorStatuses } from '../../../../../../constants/investorStatus';
import { checkPermissions } from '../../../../../../helpers/checkPermissionHelper';
import { buildRegionizeRoute } from '../../../../../../helpers/regionRouteHelper';
import { InvestorService } from '../../../../../../views/investors/investorService';
import MenuPopover from '../../../shared/components/menuPopover';

const NotificationType = {
	Operations: 1,
	Compliance: 2,
	Credit: 3,
	ProInvestor: 4
};

export default function NotificationsPopover() {
	const anchorRef = useRef(null);
	const investorService = new InvestorService();
	// const borrowerService = new BorrowerService();
	// const loanService = new LoanService();
	// const transactionService = new TransactionService();

	const [becomeProCount, setBecomeProCount] = useState(0);
	// const [transactionCount, setTransactionCount] = useState(0);
	// const [onBoardingInvestorCount, setOnBoardingInvestorCount] = useState(0);
	const [passportExpiryCount, setPassportExpiryCount] = useState(0);
	// const [compliance1Count, setCompliance1Count] = useState(0);
	// const [compliance2Count, setCompliance2Count] = useState(0);
	// const [creditAnalysisCount, setCreditAnalysisCount] = useState(0);
	const [annualReviewCount, setAnnualReviewCount] = useState(0);

	const [open, setOpen] = useState(null);

	const [notificationType, setNotificationType] = useState(
		NotificationType.Operations
	);

	const navigate = useNavigate();

	const handleOpen = (event, type) => {
		setNotificationType(type);
		setOpen(event.currentTarget);
	};

	const handleClose = () => {
		setOpen(null);
	};

	const checkIfNumber = (value) => {
		return isNaN(value) ? 0 : value;
	};

	const getAllCount = () => {
		// if (checkPermissions(RolesTypes.Transactions)) {
		// 	transactionService.getTransactionCount().then((resp) => {
		// 		setTransactionCount(resp.data);
		// 	});
		// }
		if (checkPermissions(RolesTypes.Investors)) {
			investorService.investorBecomeProCount().then((resp) => {
				setBecomeProCount(checkIfNumber(resp.data));
			});
			// investorService
			// 	.getInvestorCountByStatus(InvestorStatuses.Pending)
			// 	.then((resp) => {
			// 		setOnBoardingInvestorCount(checkIfNumber(resp.data));
			// 	});
			investorService
				.getAnnualReviewCount(InvestorStatuses.Pending)
				.then((resp) => {
					setAnnualReviewCount(checkIfNumber(resp.data));
				});
			investorService.getPassportExpiryCount().then((resp) => {
				setPassportExpiryCount(checkIfNumber(resp.data));
			});
		}

		// if (checkPermissions(RolesTypes.Loans)) {
		// 	loanService
		// 		.getLoanCountByStatus(LoanStatuses.CreditAnalysis)
		// 		.then((resp) => {
		// 			setCreditAnalysisCount(checkIfNumber(resp.data));
		// 		});

		// 	loanService.getLoanCountByStatus(LoanStatuses.Compliance).then((resp) => {
		// 		setCompliance2Count(checkIfNumber(resp.data));
		// 	});
		// }

		// if (checkPermissions(RolesTypes.Borrowers)) {
		// 	borrowerService
		// 		.getBorrowerCountByStatus(BorrowerStatuses.ApprovedByAM)
		// 		.then((resp) => {
		// 			setCompliance1Count(checkIfNumber(resp.data));
		// 		});
		// }
	};

	useEffect(() => {
		getAllCount();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onNavigate = (url, params = null) => {
		navigate({
			pathname: buildRegionizeRoute(url),
			search: params,
		});
	};

	// const getOperationsTotalCount = () => {
	// 	return +onBoardingInvestorCount + +transactionCount + +passportExpiryCount;
	// };

	const getNotificationTotalCount = () => {
		return +annualReviewCount + +passportExpiryCount + +becomeProCount;
	};

	// const getComplianceTotalCount = () => {
	// 	return (
	// 		+compliance1Count +
	// 		+compliance2Count +
	// 		+annualReviewCount
	// 	);
	// };

	// const getLoanTotalCount = () => {
	// 	return +creditAnalysisCount;
	// };

	const operationsItems = () => {
		return (
			<List>
				{/* {checkPermissions(RolesTypes.Investors) ? (
					<>
						<ListItem
							onClick={() => {
								handleClose();
								onNavigate(`${AppRoutes.Investor}/${AppRoutes.Onboarding}`);
							}}
							key={'Onboarding'}
							disablePadding
							secondaryAction={
								<Badge
									showZero={true}
									className="-mt-2 mx-2"
									color="error"
									badgeContent={onBoardingInvestorCount}></Badge>
							}>
							<ListItemButton>
								<IconButton className="!icon-bg-color !mr-2">
									<PeopleAltIcon />
								</IconButton>
								<ListItemText
									secondary={'Onboarding Investors'}
									className="caption"
								/>
							</ListItemButton>
						</ListItem>
						<Divider />
					</>
				) : null} */}
				{/* {checkPermissions(RolesTypes.Transactions) ? (
					<>
						<ListItem
							onClick={() => {
								handleClose();
								onNavigate(AppRoutes.Transactions, 'isConfirmed=false');
							}}
							key={'transactions'}
							disablePadding
							secondaryAction={
								<Badge
									max={99999}
									showZero={true}
									className="-mt-2 mx-2"
									color="error"
									badgeContent={transactionCount}></Badge>
							}>
							<ListItemButton>
								<IconButton className="!icon-bg-color !mr-2">
									<PaidIcon />
								</IconButton>
								<ListItemText
									secondary={'Transactions'}
									className="caption"
								/>
							</ListItemButton>
						</ListItem>
						<Divider />
					</>
				) : null} */}
				{checkPermissions(RolesTypes.Investors) ? (
					<>
						<ListItem
							onClick={() => {
								handleClose();
								onNavigate(
									`${AppRoutes.Investor}/${AppRoutes.IAll}`,
									`HasPassedAnnualReviewDate=true`
								);
							}}
							key={'Review'}
							disablePadding
							secondaryAction={
								<Badge
									max={99999}
									showZero={true}
									className="-mt-2 mx-2"
									color="error"
									badgeContent={annualReviewCount}></Badge>
							}>
							<ListItemButton>
								<IconButton className="!icon-bg-color !mr-2">
									<PreviewIcon />
								</IconButton>
								<ListItemText
									secondary={'Annual Review Date'}
									className="caption"
								/>
							</ListItemButton>
						</ListItem>
						<ListItem
							onClick={() => {
								handleClose();
								onNavigate(
									`${AppRoutes.Investor}/${AppRoutes.IAll}`,
									`HasPassportExpired=true`
								);
							}}
							key={'Passportexpiry '}
							disablePadding
							secondaryAction={
								<Badge
									max={99999}
									showZero={true}
									className="-mt-2 mx-2"
									color="error"
									badgeContent={passportExpiryCount}></Badge>
							}>
							<ListItemButton>
								<IconButton className="!icon-bg-color !mr-2">
									<HourglassBottomIcon />
								</IconButton>
								<ListItemText
									secondary={'Wind down'}
									className="caption"
								/>
							</ListItemButton>
						</ListItem>
						<ListItem
							onClick={() => {
								handleClose();
								onNavigate(
									`${AppRoutes.Investor}/${AppRoutes.Iapproved}`,
									`?becameProInvestorRequestStatus=${BecomeProStatuses.Requested}`
								);
							}}
							key={'Investors '}
							disablePadding
							secondaryAction={
								<Badge
									max={99999}
									showZero={true}
									className="-mt-2 mx-2"
									color="error"
									badgeContent={becomeProCount}></Badge>
							}>
							<ListItemButton>
								<IconButton className="!icon-bg-color !mr-2">
									<ManageAccountsIcon />
								</IconButton>
								<ListItemText
									secondary={'Pro Investors '}
									className="caption"
								/>
							</ListItemButton>
						</ListItem>
					</>
				) : null}
				{/* <Divider />
				<ListItem
					onClick={() => {
						handleClose();
						onNavigate(AppRoutes.Notification);
					}}
					key={'notifications'}
					disablePadding
					secondaryAction={
						<Badge
							showZero={true}
							className="-mt-2 mx-2"
							color="error"
							badgeContent={notificationCount}></Badge>
					}>
					<ListItemButton>
						<IconButton className="!icon-bg-color !mr-2">
							<NotificationsIcon />
						</IconButton>
						<ListItemText
							secondary={'Notifications'}
							className="caption"
						/>
					</ListItemButton>
				</ListItem> */}
			</List>
		);
	};

	// const creditItems = () => {
	// 	return (
	// 		<List>
	// 			<ListItem
	// 				onClick={() => {
	// 					handleClose();
	// 					onNavigate(`${AppRoutes.Loans}/${AppRoutes.Lcredit}`);
	// 				}}
	// 				key={'CreditAnalysis'}
	// 				disablePadding
	// 				secondaryAction={
	// 					<Badge
	// 						max={99999}
	// 						showZero={true}
	// 						className="-mt-2 mx-2"
	// 						color="error"
	// 						badgeContent={creditAnalysisCount}></Badge>
	// 				}>
	// 				<ListItemButton>
	// 					<IconButton className="!icon-bg-color !mr-2">
	// 						<AccountBalanceWalletIcon />
	// 					</IconButton>
	// 					<ListItemText
	// 						secondary={'Credit Analysis'}
	// 						className="caption"
	// 					/>
	// 				</ListItemButton>
	// 			</ListItem>
	// 		</List>
	// 	);
	// };

	// const proInvestorItems = () => {
	// 	return <List>
	// 		{checkPermissions(RolesTypes.Investors) ? (
	// 			<>
	// 				<ListItem
	// 					onClick={() => {
	// 						handleClose();
	// 						onNavigate(
	// 							`${AppRoutes.Investor}/${AppRoutes.Iapproved}`,
	// 							`?becameProInvestorRequestStatus=${BecomeProStatuses.Requested}`
	// 						);
	// 					}}
	// 					key={'Investors '}
	// 					disablePadding
	// 					secondaryAction={
	// 						<Badge
	// 							max={99999}
	// 							showZero={true}
	// 							className="-mt-2 mx-2"
	// 							color="error"
	// 							badgeContent={becomeProCount}></Badge>
	// 					}>
	// 					<ListItemButton>
	// 						<IconButton className="!icon-bg-color !mr-2">
	// 							<ManageAccountsIcon />
	// 						</IconButton>
	// 						<ListItemText
	// 							secondary={'Pro Investors '}
	// 							className="caption"
	// 						/>
	// 					</ListItemButton>
	// 				</ListItem>
	// 			</>
	// 		) : null}
	// 	</List>;
	// };

	// const complianceItems = () => {
	// 	return (
	// 		<List>
	// 			{checkPermissions(RolesTypes.Borrowers) ? (
	// 				<>
	// 					<ListItem
	// 						onClick={() => {
	// 							handleClose();
	// 							onNavigate(`${AppRoutes.Borrowers}/${AppRoutes.Bcompliance}`);
	// 						}}
	// 						key={'Compliance_1'}
	// 						disablePadding
	// 						secondaryAction={
	// 							<Badge
	// 								max={99999}
	// 								showZero={true}
	// 								className="-mt-2 mx-2"
	// 								color="error"
	// 								badgeContent={compliance1Count}></Badge>
	// 						}>
	// 						<ListItemButton>
	// 							<IconButton className="!icon-bg-color !mr-2">
	// 								<ChecklistRtlIcon />
	// 							</IconButton>
	// 							<ListItemText
	// 								secondary={'Pushed to Compliance 1'}
	// 								className="caption"
	// 							/>
	// 						</ListItemButton>
	// 					</ListItem>
	// 					<Divider />
	// 				</>
	// 			) : null}
	// 			{checkPermissions(RolesTypes.Loans) ? (
	// 				<>
	// 					<ListItem
	// 						onClick={() => {
	// 							handleClose();
	// 							onNavigate(`${AppRoutes.Loans}/${AppRoutes.Lcompliance}`);
	// 						}}
	// 						key={'Compliance_2'}
	// 						disablePadding
	// 						secondaryAction={
	// 							<Badge
	// 								max={99999}
	// 								showZero={true}
	// 								className="-mt-2 mx-2"
	// 								color="error"
	// 								badgeContent={compliance2Count}></Badge>
	// 						}>
	// 						<ListItemButton>
	// 							<IconButton className="!icon-bg-color !mr-2">
	// 								<FactCheckIcon />
	// 							</IconButton>
	// 							<ListItemText
	// 								secondary={'Pushed to Compliance 2'}
	// 								className="caption"
	// 							/>
	// 						</ListItemButton>
	// 					</ListItem>
	// 					<Divider />
	// 				</>
	// 			) : null}
	// 			{checkPermissions(RolesTypes.Investors) ? (
	// 				<ListItem
	// 					onClick={() => {
	// 						handleClose();
	// 						onNavigate(
	// 							`${AppRoutes.Investor}/${AppRoutes.IAll}`,
	// 							`HasPassedAnnualReviewDate=true`
	// 						);
	// 					}}
	// 					key={'Review'}
	// 					disablePadding
	// 					secondaryAction={
	// 						<Badge
	// 							max={99999}
	// 							showZero={true}
	// 							className="-mt-2 mx-2"
	// 							color="error"
	// 							badgeContent={annualReviewCount}></Badge>
	// 					}>
	// 					<ListItemButton>
	// 						<IconButton className="!icon-bg-color !mr-2">
	// 							<PreviewIcon />
	// 						</IconButton>
	// 						<ListItemText
	// 							secondary={'Annual Review'}
	// 							className="caption"
	// 						/>
	// 					</ListItemButton>
	// 				</ListItem>
	// 			) : null}
	// 		</List>
	// 	);
	// };

	const operationsItemsPermissions = () => {
		return checkPermissions('', [
			RolesTypes.Investors,
			RolesTypes.Transactions,
		]);
	};

	// const creditItemsPermissions = () => {
	// 	return checkPermissions('', [RolesTypes.Loans]);
	// };

	// const complianceItemsPermissions = () => {
	// 	return checkPermissions('', [
	// 		RolesTypes.Investors,
	// 		RolesTypes.Borrowers,
	// 		RolesTypes.Loans,
	// 	]);
	// };

	return (
		<>
			{operationsItemsPermissions() ? (
				<IconButton
					className="!bg-white shadow-xl"
					ref={anchorRef}
					color={open ? 'primary' : 'default'}
					onClick={(event) => {
						handleOpen(event, NotificationType.Operations);
					}}
					sx={{ width: 35, height: 35 }}>
					<Badge
						max={99999}
						showZero={true}
						badgeContent={getNotificationTotalCount()}
						color="error">
						<img
							className="w-5"
							src={OperationImage}
							alt=""></img>
					</Badge>
				</IconButton>
			) : null}
			{/* {complianceItemsPermissions() ? (
				<IconButton
					className="!bg-white shadow-xl"
					ref={anchorRef}
					color={open ? 'primary' : 'default'}
					onClick={(event) => {
						handleOpen(event, NotificationType.Compliance);
					}}
					sx={{ width: 35, height: 35 }}>
					<Badge
						max={99999}
						showZero={true}
						badgeContent={getComplianceTotalCount()}
						color="error">
						<img
							className="w-5"
							src={ComplainceImage}
							alt=""></img>
					</Badge>
				</IconButton>
			) : null}
			{creditItemsPermissions() ? (
				<IconButton
					className="!bg-white shadow-xl"
					ref={anchorRef}
					color={open ? 'primary' : 'default'}
					onClick={(event) => {
						handleOpen(event, NotificationType.Credit);
					}}
					sx={{ width: 35, height: 35 }}>
					<Badge
						max={99999}
						showZero={true}
						badgeContent={getLoanTotalCount()}
						color="error">
						<img
							className="w-5"
							src={CreditImage}
							alt=""></img>
					</Badge>
				</IconButton>
			) : null}
			{checkPermissions(RolesTypes.Investors) ? (
				<IconButton
					className="!bg-white shadow-xl"
					ref={anchorRef}
					color={open ? 'primary' : 'default'}
					onClick={(event) => {
						handleOpen(event, NotificationType.ProInvestor);
					}}
					sx={{ width: 35, height: 35 }}>
					<Badge
						max={99999}
						showZero={true}
						badgeContent={becomeProCount}
						color="error">
						<PeopleOutlineOutlinedIcon className='!text-[#716e6e]' />
					</Badge>
				</IconButton>
			) : null} */}
			<MenuPopover
				open={Boolean(open)}
				anchorEl={open}
				onClose={handleClose}
				sx={{ width: 230, p: 0, mt: 1.5, ml: 0.75 }}>
				<Box sx={{ display: 'flex', alignItems: 'center' }}>
					<Box sx={{ flexGrow: 1 }}>
						{notificationType === NotificationType.Operations &&
							operationsItems()}
						{/* {notificationType === NotificationType.Compliance &&
							complianceItems()}
						{notificationType === NotificationType.Credit && creditItems()}
						{notificationType === NotificationType.ProInvestor && proInvestorItems()} */}
					</Box>
				</Box>
			</MenuPopover>
		</>
	);
}
